(function($) {

    $(".account__reminders__item-remove").on("click", function (){
        if ($(this).hasClass("processing")){
            return
        }
        $(this).addClass("processing")

        if (!confirm(scripts_translations.my_account.reminder.confirm_delete)){
            $(this).removeClass("processing")
            return
        }

        const reminder_id = $(this).attr("data-myaccount-reminder-id")
        const ajax_url = $(this).attr("data-action")
        if (reminder_id && ajax_url){
            gp_ajax({
                url: ajax_url,
                type: "post",
                data: {
                    "product_variant_restock_reminder_id": reminder_id,
                }
            })
        }
    })

})(jQuery);